import { useEffect, useRef } from "react";
import axios from "axios";
import { useBulkOCR } from "../context/BulkOCRContext";

const POLL_MS = 3000;

export default function useOCRPolling(token, shouldPoll) {
  const { state, dispatch } = useBulkOCR();
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(async () => {
      if (!shouldPoll) return;
      // pick only groups that aren’t done or errored yet
      const active = state.groups.filter(
        (g) =>
          (g.status === "queued" || g.status === "processing") &&
          g.inputType === "ocr"
      );

      await Promise.all(
        active.map(async (g) => {
          try {
            const response = await axios
              .post(
                `${process.env.REACT_APP_API_HOST}/v2/job/getJobById`,
                { _id: g.id, jobType: "ocr" },
                { headers: { Authorization: `Bearer ${token}` } }
              )
              .catch((err) => {
                console.error("poll error", err);
                dispatch({ type: "SET_ERROR", id: g.id, error: err.message });
              });
            const pollData = response.data;
            console.log("poll data", pollData);
            if (pollData.status === "completed") {
              const response = await axios
                .post(
                  `${process.env.REACT_APP_API_HOST}/v2/job/getDataById`,
                  { _id: g.id, dataType: "ocr" },
                  { headers: { Authorization: `Bearer ${token}` } }
                )
                .catch((err) => {
                  console.error("poll error", err);
                  dispatch({
                    type: "SET_ERROR",
                    id: g.id,
                    error: err.message,
                    status: "completed",
                  });
                });
              const data = response.data.data;
              console.log("getdata", response);
              // if (data.results && data.results.length > 0) {
              //   // const text = data.results
              //   //   .map((item) => item.text)
              //   //   .join("\n");
              //   const text = data.result.text
              //   console.log("text", text);
              //   dispatch({
              //     type: "SET_TEXT",
              //     id: g.id,
              //     text: text,
              //     status: "completed",
              //   });
              // }
              if (data.result) {
                const text = data.result.text;
                console.log("text", text);
                dispatch({
                  type: "SET_TEXT",
                  id: g.id,
                  text: text,
                  status: "completed",
                });
              }
            } else if (
              pollData.status === "processing" ||
              pollData.status === "queued"
            ) {
              dispatch({
                type: "UPDATE_STATUS",
                id: g.id,
                status:
                  pollData.status === "processing" ? "processing" : "queued",
              });
            } else if (pollData.status === "error") {
              dispatch({ type: "SET_ERROR", id: g.id, error: pollData.error });
            }
          } catch (err) {
            console.error("poll error", err);
            // optional: surface a toast but keep polling
          }
        })
      );
    }, POLL_MS);

    return () => clearInterval(timerRef.current);
  });
}
